import { makeVar } from "@apollo/client";
import { debounce } from "lodash";

export const clientStateVar = makeVar({});
export const deviceSizeVar = makeVar(0);

const setWindowSize = debounce(() => {
  deviceSizeVar(window.innerWidth);
}, 20);

window.addEventListener("resize", setWindowSize, false);

setWindowSize();
